import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const CardBannerInformation = ({ judul, slug, image }) => (
    <div className="h-40 lg:h-1/3 w-full hover:scale-110 transition-all delay-100" style={{ backgroundImage: `url(${image})`, backgroundSize: 'cover', backgroundPosition: 'center center' }}>
        <Link to={`/${slug}`} className="flex justify-end content-end h-full bg-black bg-opacity-30" >
            <div className="flex items-end pb-8 pr-8">
                <p className="font-bold text-white text-xl hover:text-2xl transition-all delay-100 hover:bg-black hover:bg-opacity-40 px-8 py-1">{judul}</p>
            </div>
        </Link >
    </div >
);

const Header = () => {
    return (
        <>
            <Helmet>
                <title>Gili Iyang</title>
                <meta name="description" content="Helmet application" />
            </Helmet>
            <div className="flex flex-col lg:flex-row w-full pt-20 lg:mb-12">
                <div className="flex lg:w-2/3" data-aos="fade-up" data-aos-anchor-placement="center-bottom">
                    <div className="h-[520px] lg:h-[680px]" style={{ backgroundImage: `url(https://res.cloudinary.com/dkltotiq0/image/upload/v1675946981/banraas%2C%20gili-iyang/IMG20190819074642_utrsod.jpg)`, backgroundSize: 'cover', backgroundPosition: 'center center' }}>
                        <div className="px-12 lg:px-36 h-full w-full bg-black bg-opacity-30 flex content-center">
                            <div className="text-start text-white my-auto">
                                <h1 className="text-4xl lg:text-5xl font-bold py-4">Berwisata di Pulau Oksigen Gili Iyang.</h1>
                                <h4 className="text-2xl lg:text-2xl">Tambahkan pengalaman dalam sejarah perjalanan mu</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="lg:w-1/3" data-aos="fade-up" data-aos-anchor-placement="center-bottom">
                    <CardBannerInformation
                        judul="Wisata Alam Pantai Ropet"
                        image="https://res.cloudinary.com/dkltotiq0/image/upload/v1675948107/banraas%2C%20gili-iyang/pantai_ropet_bqi9ll.jpg"
                        slug="pantai-ropet"
                    />
                    <CardBannerInformation
                        judul="Tradisi Pembacaan Al-Qur’an Zymat"
                        image="https://res.cloudinary.com/dkltotiq0/image/upload/v1675948333/banraas%2C%20gili-iyang/quran_zymat_woxp3w.png"
                        slug="alquran-zymat"
                    />
                    <CardBannerInformation
                        judul="Petilasan dan Goa Petapan"
                        image="https://res.cloudinary.com/dkltotiq0/image/upload/v1675948604/banraas%2C%20gili-iyang/photo_2022-12-29_22-03-15_xtqcne.jpg"
                        slug="goa-petapan"
                    />
                </div>
            </div>
        </>
    )
}

export default Header;